module["exports"] = [
  "/6767-####-####-###L/",
  "/6767-####-####-####-#L/",
  "/6767-####-####-####-##L/"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/credit_card/solo.js
 ** module id = 306
 ** module chunks = 0
 **/